import React from 'react'


const ErrorBlockGeneric = ({ error }: { error?: string | null }) => {
  if (!error) return null;

  return (
    <div className="alert bg-danger p-2 rounded-xl my-1">
      <h1 className="text-xl text-center">Errore</h1>
      <span>{JSON.stringify(error, null, 2)}</span>
    </div>
  )
}


export default ErrorBlockGeneric;
